import { render, staticRenderFns } from "./BusinessEdit.vue?vue&type=template&id=2dc4dfc2&"
import script from "./BusinessEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports